<template>
    <div class="mt-4 row">
        <div :class="blockSize" v-for="(file, index) of block.files">
            <file-block :file="file"
                        style="cursor: pointer;"
                        :ceremony-code="code"
                        :show-actions="false"
                        :show-warnings="false"
                        :show-play="canPlayBlock"
                        :active="block.id === activeBlockId && currentFileIndex === index"
                        @click="showFile(file)"
            />
        </div>
    </div>
</template>

<script>

    import FileBlock from './FileBlock';

    export default {

        components: {
            FileBlock,
        },

        props: {
            block: {
                type: Object,
                required: true,
            },
            code: {
                type: String,
                required: true,
            },
            blockSize: {
                type: String,
                default: 'col-4 col-sm-4 col-xs-4 col-md-2 col-lg-1 mb-2',
            },
            activeBlockId: {
                type: Number | null,
                required: true,
            },
            currentFileIndex: {
                type: Number | null,
                required: true,
            },
            canPlayBlock: {
                type: Boolean,
                default: true,
            },
        },

        methods: {
            showFile(file) {
                if (!this.canPlayBlock) {
                    return;
                }

                this.$emit('show-file', file);
            },
        },
    };

</script>
